module.exports = __webpack_public_path__ + "img/logo_login.a08b049a.png";